import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { ChecklistReportLastActivePeriodStatusBase } from '../checklist-report-last-active-period-status-base';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';

@Component({
    selector: 'fi-checklist-report-last-active-period-status-column',
    templateUrl: './checklist-report-last-active-period-status-column.component.html',
    styleUrls: ['./checklist-report-last-active-period-status-column.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-checklist-report-last-active-period-status-column' },
    standalone: false,
})
export class ChecklistReportLastActivePeriodStatusColumnComponent extends ChecklistReportLastActivePeriodStatusBase {
    FiStateNames = FiStateNames;
}
